import {CHANGE_VIEW, CHANGE_VISIBLE_STATE, CHANGE_VISIBLE_STATE_MENU} from '../actions/accountModalActions';

const initialState = {
    open: false
};

const accountModalReducer = function(state = initialState, action) {

    switch ( action.type ) {
        case CHANGE_VISIBLE_STATE_MENU:
            return Object.assign(
                {}, state,
                {
                    menuOpen:action.open===true
                }
            );
        case CHANGE_VIEW:
        case CHANGE_VISIBLE_STATE:
            return Object.assign(
                {}, state,
                {

                    view:action.view,
                    open:action.open===true,
                    menuOpen:false
                }
            );
        default:
            return state;
    }
};

export default accountModalReducer;
